import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { TermsService } from '@go-modules/services/terms/terms.service';

@Component({
	selector: 'terms-of-use-dialog',
	templateUrl: './terms-of-use-dialog.component.html',
	styleUrls: ['./terms-of-use-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class TermsOfUseDialogComponent implements OnInit {

	public form: UntypedFormGroup;

	constructor (
		private dialogRef: MatDialogRef<TermsOfUseDialogComponent>,
		private termsService: TermsService
	) {
		this.dialogRef.disableClose = true;
	}

	public ngOnInit () {
		this.form = new UntypedFormGroup({
			acceptTerms: new UntypedFormControl(false, [Validators.requiredTrue])
		});
	}

	public accept () {
		if (this.form.valid) {
			this.termsService.accept();
			this.dialogRef.close();
		}
	}
}
